import React, { useEffect, useState } from 'react';
import { collection, deleteDoc, doc, getDoc, onSnapshot, orderBy, query, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../../../../firebase';
import { Accordion, Badge, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { MdAdd } from 'react-icons/md';
import { IoCreateOutline, IoInformationCircleOutline } from 'react-icons/io5';
import { useAuth } from '../../../../../context/AuthContext';
import Payments from './payments';

const PaymentPlans = ({ propertyItems, towerID, handleShowPayment, handleShowPlan, setPlanID, setPaymentPlanData }) => {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);

  function getPlans() {
    const q = query(collection(db, "Businesses", bid, "Properties", propertyItems.id, "PaymentPlans"), orderBy("serialNumber"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        if (doc.data().towerID === towerID) {
          tempData.push({ id: doc.id, ...doc.data(), payments: [] });
        }
      });

      setData(tempData);
    }, (error) => {
      console.log(error.message);
      setIsLoading(false);
    });

    return () => unsubscribe;
  }

  useEffect(() => {
    getPlans();
  }, []);

  return (
    <div className='border rounded overflow-hidden'>
      <div className='bg-primary-light mb-0 d-flex justify-content-between'>
        <h5 className='mb-0 py-3 px-3'>Payment Plan</h5>
        <div className='px-3 d-flex align-items-center'>
          <OverlayTrigger placement="auto-start" overlay={<Tooltip><b>BP</b> is Basic Price<br /><b>AC</b> is Additional Charges</Tooltip>}>
            <a href="#">
              <IoInformationCircleOutline size={20} />
            </a>
          </OverlayTrigger>
        </div>
      </div>
      {
        data && data.length > 0 ?
          <Accordion defaultActiveKey={0} flush>
            {
              data && data.map((plan, planIndex) => {
                return (
                  <Accordion.Item key={planIndex} eventKey={planIndex}>
                    <Accordion.Header className='rounded-none sticky-top'>
                      <span className='fw-600 me-2'>{plan.serialNumber}.</span>
                      <span className='fw-600'>{plan.name}</span>
                    </Accordion.Header>
                    <Accordion.Body className='p-0'>
                      <div className='mx-h-500 h-100 overflow-scroll'>
                        <div className='border-top'>
                          <Payments
                            propertyItems={propertyItems}
                            towerID={towerID}
                            planID={plan.id}
                            handleShowPayment={handleShowPayment}
                            setPlanID={setPlanID}
                            setPaymentPlanData={setPaymentPlanData}
                          />
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                )
              })
            }
          </Accordion>
          :
          <div className='mx-3 mb-3 mt-4'>
            <Button
              variant='white'
              className='w-100 py-5 border-long-dashed rounded border-0 shadow-none'
              onClick={handleShowPlan}
            >
              <MdAdd size={20} color={`var(--bs-primary)`} />
              <span className='ms-1 text-primary'>Create Plans</span>
            </Button>
          </div>
      }
    </div>
  )
}

export default PaymentPlans;
